export default __webpack_public_path__ + "static/media/page4.18608824.png";